<div class="w-11/12 mx-auto px-6 py-8" data-aos="fade-up">
  <div class="flex items-center justify-between border-b-2 border-yellow-400 pb-2 mb-6">
    <div class="text-xl text-primary-600">{{ 'Habari na Matukio'|concat|translate }}</div>
  </div>

  <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 pt-2">
    <div class="lg:col-span-1 grid grid-cols-2 gap-6" appSequentialAnimate direction="right"
         *ngIf="topNews$ | async as topNews">
      <ng-container *ngFor="let n of topNews; let i = index">
        <div class="w-full cursor-pointer group"
             routerLink="/news-view/{{n?.uniqueId}}"
             data-aos="flip-left"
             [attr.data-aos-delay]="i * 100">
          <div class="relative rounded-md overflow-hidden">
            <img [ngSrc]="fileUrl+ n?.images[0]"
                 alt=""
                 [height]="160"
                 [width]="160"
                 (load)="onImageLoad($event)"
                 class="w-full h-40 object-cover opacity-10 transition-opacity duration-300">

            <div class="absolute inset-0 bg-black/30 opacity-0
                    group-hover:opacity-100 transition"></div>
            <div class="matukioOverlay"></div>
            <p class="absolute bottom-0 left-0 right-0
                  px-3 text-white text-xs">
              {{ n?.title| truncate:70 }}
            </p>
          </div>

        </div>
      </ng-container>
    </div>


    <div class="lg:col-span-2 " data-aos="fade-left" *ngIf="carouselItems$ |async as carouselitems">
      <div class="relative h-[260px] md:h-[345px] w-full rounded-md overflow-hidden" *ngIf="!!carouselitems?.length">
        <app-portal-flip-carousel (activeIndex)="activeCarousel=$event"
                                  class="absolute inset-0 w-full h-full object-cover" [height]="'full'"
                                  [images]="carouselImages(carouselitems)">
        </app-portal-flip-carousel>
        <div class="infoPicha"></div>
        <div class="relative z-10 h-full flex items-end w-6/12  px-10 md:px-16 text-yellow-400">
          <p
            class="text-xl md:text-3xl leading-relaxed !mb-10 font-semibold ">{{ carouselitems[activeCarousel]?.title | truncate:70 }}</p>
        </div>

        <div class="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-1.5 z-10">
          <ng-container *ngFor="let n of carouselitems; let i=index">
                  <span class="inline-block h-1.5 w-1.5 rounded-full transition"
                        [ngClass]="{'bg-yellow-400': activeCarousel === i, 'bg-yellow-400/40': activeCarousel !== i}"
                        (click)="showSlide(i)">
                  </span>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
